export default __webpack_public_path__ + "static/media/王有德.33ebe338.jpg";